import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-terminate',
  templateUrl: './terminate.component.html',
  styleUrls: ['./terminate.component.scss'],
  standalone: false
})
export class TerminateComponent implements OnInit {
  status: string | null = null;
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.status = this.route.snapshot.queryParamMap.get('status');
  }

  get message(): string {
    if (!this.status) return 'Thank you for joining, but you are not allowed to complete the survey.';
    if (this.status === 'success') return 'Thank you for completing the survey.';
  }
}
